export default {
    methods: {
        resetStepData() {
            this.setCurrentStepData('');
        },
        setCurrentStepData(value) {
            if (this.currentStep) {
                this.setStepData({
                    name: this.currentStep.type,
                    value: value
                });
            }
        }
    },
    computed: {
        customerInfo() {
          return this.fields.filter(field => field.integration !='scheduling');
        },
        schedulingSteps() {
          var fields = this.fields.filter(field => field.integration =='scheduling');
          fields.forEach((field,index) => field.step=index);
          return fields;
        },
        currentStep() {
            if (this.schedulingSteps[this.step]) {
                return this.schedulingSteps[this.step];
            } else {
                return null;
            }
        },
        stepIsValid() {
            return this.schedulingSteps[this.step] !== undefined;
        },
        showCustomerStep() {
            return !this.stepIsValid && this.step > 0;
        },
        isNotFirstStep() {
            return this.field.step > 0;
        },
        stepWrapperCustomClassByType() {
            return 'step-'+this.field.type;
        },
        stepWrapperCustomClassByStep() {
            return 'step-'+this.field.step;
        },
        stepWrapperClasses() {
            return {
                "step-field": true,
                "form-group": true,
                [this.stepWrapperCustomClassByType] : true,
                [this.stepWrapperCustomClassByStep]: true,
            }
        }
    }
};
